import { cn } from '../../lib/cn';
import type { SettlementRow } from '../../financialintel/framework';

type Props = { settlements?: SettlementRow[] };

function statusColor(status: string) {
  switch (status) {
    case 'reconciled': return 'bg-success-100 text-success-700 dark:bg-success-950 dark:text-success-300';
    case 'review': return 'bg-warning-100 text-warning-700 dark:bg-warning-950 dark:text-warning-300';
    default: return 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400';
  }
}

export function SettlementIntelligencePanel({ settlements = [] }: Props) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-left text-sm">
        <thead>
          <tr className="border-b border-slate-200 text-xs uppercase text-slate-500 dark:border-slate-700">
            <th className="pb-2 pr-4 font-medium">Settlement</th>
            <th className="pb-2 pr-4 font-medium">Expected</th>
            <th className="pb-2 pr-4 font-medium">Actual</th>
            <th className="pb-2 pr-4 font-medium">Variance</th>
            <th className="pb-2 font-medium">Status</th>
          </tr>
        </thead>
        <tbody>
          {settlements.map((s) => (
            <tr key={s.id} className="border-b border-slate-100 dark:border-slate-800">
              <td className="py-2.5 pr-4 font-medium">{s.id}</td>
              <td className="py-2.5 pr-4">{s.expected}</td>
              <td className="py-2.5 pr-4">{s.actual}</td>
              <td className={cn('py-2.5 pr-4 font-medium', s.variance.startsWith('-') ? 'text-error-600' : 'text-success-600')}>
                {s.variance}
              </td>
              <td className="py-2.5">
                <span className={cn('rounded-full px-2 py-0.5 text-xs font-medium capitalize', statusColor(s.status))}>
                  {s.status}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
